import { baseApi } from '@/services/api';
import { GitHubRepository, GitHubDeployment } from './githubTypes';

export const githubAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Connection
    connectGitHub: builder.mutation<{ auth_url: string }, void>({
      query: () => ({
        url: '/github/connect',
        method: 'POST',
      }),
    }),
    
    disconnectGitHub: builder.mutation<void, void>({
      query: () => ({
        url: '/github/disconnect',
        method: 'POST',
      }),
      invalidatesTags: ['Integrations'],
    }),
    
    getGitHubStatus: builder.query<{ connected: boolean; username?: string }, void>({
      query: () => ({
        url: '/github/status',
        method: 'GET',
      }),
      providesTags: ['Integrations'],
    }),
    
    // Repositories
    getRepositories: builder.query<GitHubRepository[], void>({
      query: () => ({
        url: '/github/repositories',
        method: 'GET',
      }),
      providesTags: ['Integrations'],
    }),
    
    createRepository: builder.mutation<GitHubRepository, {
      name: string;
      description: string;
      private?: boolean;
      auto_init?: boolean;
      gitignore_template?: string;
      license_template?: string;
    }>({
      query: (data) => ({
        url: '/github/repositories',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Integrations'],
    }),
    
    linkProjectToRepo: builder.mutation<void, { project_id: string; repo_name: string }>({
      query: (data) => ({
        url: '/github/link',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Projects', 'Integrations'],
    }),
    
    // Deployments
    deployToGitHub: builder.mutation<GitHubDeployment, {
      project_id: string;
      repo_name: string;
      branch?: string;
      environment?: string;
    }>({
      query: (data) => ({
        url: '/github/deploy',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Deployments'],
    }),
    
    getGitHubDeployments: builder.query<GitHubDeployment[], { repo_name?: string }>({
      query: (params) => ({
        url: '/github/deployments',
        method: 'GET',
        params,
      }),
      providesTags: ['Deployments'],
    }),
  }),
});

export const {
  useConnectGitHubMutation,
  useDisconnectGitHubMutation,
  useGetGitHubStatusQuery,
  useGetRepositoriesQuery,
  useCreateRepositoryMutation,
  useLinkProjectToRepoMutation,
  useDeployToGitHubMutation,
  useGetGitHubDeploymentsQuery,
} = githubAPI;
